import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useExportRoomsExcel } from "../useExportRoomsExcel";
import type { PlanExportAction } from "components/SmartSurveyor/ReviewPage/PlanNameChip";
import type { UsePlanExportActions } from "./types";

const EMPTY_ACTIONS: PlanExportAction[] = [];

export const usePlanExportActions: UsePlanExportActions = ({
  selectedPlan,
  isCablesView,
  isExecutionMode,
  routeGroups,
  groupIds,
  byGroupId,
  rooms,
  boqPositions,
  onExportPdf,
}) => {
  const { t } = useTranslation();

  const { handleExportRoomsExcel } = useExportRoomsExcel({
    selectedPlan,
    rooms,
    groupIds,
    byGroupId,
    boqPositions,
  });

  const hasExportableData =
    selectedPlan !== null &&
    (isCablesView ? routeGroups.length > 0 : groupIds.length > 0);

  const planExportActions = useMemo<PlanExportAction[]>(() => {
    if (!hasExportableData) return EMPTY_ACTIONS;
    if (!isExecutionMode) {
      return [
        {
          label: t("smartSurveyor.floorPlan.downloadAnnotatedPdf"),
          onClick: onExportPdf,
        },
      ];
    }
    return [
      {
        label: t("smartSurveyor.floorPlan.exportActions.annotatedPdf"),
        onClick: onExportPdf,
      },
      {
        label: t("smartSurveyor.floorPlan.exportActions.roomsExcel"),
        onClick: handleExportRoomsExcel,
      },
    ];
  }, [
    t,
    hasExportableData,
    isExecutionMode,
    onExportPdf,
    handleExportRoomsExcel,
  ]);

  return { planExportActions };
};
